import React from 'react';
import LoginLeft from './LoginLeft';
import LoginRight from './LoginRight';

const Login: React.FC = () => {
  return (
    <div className="h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img src="/assets/login.jpg" alt="Enexan Background" className="h-full w-full object-fill" />
        {/* Dark overlay for contrast */}
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Main Login Card */}
      <div className="relative z-10 flex h-full items-center justify-center p-6">
        <div className="h-[95vh] w-full overflow-hidden rounded-3xl border border-white/20 bg-white p-2 shadow-2xl">
          <div className="grid h-full lg:grid-cols-2">
            {/* Left side - Quote Section (Hidden on mobile) */}
            <div className="relative hidden lg:block">
              <LoginLeft />
            </div>

            {/* Right side - Login form */}
            <div className="relative flex items-center justify-center bg-white">
              <LoginRight />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
